export const objectFromEntries = Object.fromEntries as <TKey extends string, TValue>(
  entries: [TKey, TValue][],
) => Record<TKey, TValue>;

export const objectEntries = Object.entries as <T>(o: T) => [keyof T, T[keyof T]][];

export const objectKeys = Object.keys as <TKey extends string>(
  o: Record<TKey, unknown> | Partial<Record<TKey, unknown>>,
) => TKey[];
